
import * as yup from 'yup';
import { DataTableHtmlFormatter } from '../../../../Component/Model/helpers';

const barriersMaxLength: number = 2400;

export const eePlanBarrierSchema = yup.object({
    eeBarrierCategoryId: yup.number().nullable().required('Category is required'),
    barriers: yup.string()
        .required('Barriers is required')
        .test('barrierLengthTest', `Barriers is too long`, value => {
            if (!value){
                return true;
            }    
            return DataTableHtmlFormatter(value, '').length <= barriersMaxLength;
        }),
    affirmativeActionMeasured: yup.string()
        .required('Affirmative Action Measures are required')
        .test('affirmativeActionLengthTest', `Affirmative Action Measures is too long`, value => {
            if (!value){
                return true;
            }    
            return DataTableHtmlFormatter(value, '').length <= barriersMaxLength;
        }),    
    responsibleDesignation: yup.string().max(150, "Responsible designation is too long. It may not exceed 150 characters"),
    startDate: yup
    .date()
    .nullable()
    .required('Start Date is required')
    .test(
        'start-before-end',
        'Start Date must be before or equal to End Date',
        function (startDate) {
            const { endDate } = this.parent;
            if (startDate && endDate) {
                return new Date(startDate) <= new Date(endDate);
            }
            return true;
        }
    ),
    endDate: yup.date().nullable().required('End Date is required')
})